import { useSelector } from 'react-redux';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import useQueryParams from '../../../navigation-utils/useQueryParams';
import { selectDocumentationActiveObjectData } from '../../../reducers/documentation/documentationReducer';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import { ConfigurationItem } from '../dependencies/DependenciesTypes';

export function useObjectContentHandleDeepLink<
  RowT extends Pick<ConfigurationItem, 'id' | 'name'>,
>({
  rows,
  onRowClick,
  elements,
}: {
  rows: RowT[];
  elements: ConfigurationItem[];
  onRowClick: (event: React.MouseEvent<HTMLTableCellElement>, row: RowT) => void;
}) {
  const queryParams = useQueryParams();
  const elementsLoaded = useSelector(selectDocumentationActiveObjectData);

  useRunOnceWhenTruthy(() => {
    const configurationItemId = queryParams.get(DeepLinkSearchParams.configurationItemId);
    if (configurationItemId) {
      const [, configurationName] = configurationItemId.split('|');
      const rowId = elements.find((element) => element.name === configurationName)?.id;
      const row = rows.find((row) => row.id === rowId);
      if (row) {
        onRowClick({ target: {} } as React.MouseEvent<HTMLTableCellElement>, row);
      }
    }
  }, Boolean(elementsLoaded));
}
